import axios from 'axios'

const BASE_URL = process.env.REACT_APP_BASE_API_URL;
const BASE_JOBSTATUS_URL = `${BASE_URL}api/jobLogger/` ;



const JobStatusService = () => (
       {
        getJobDetails: async (page, pageSize, filters, token) => {

        const { data } = await axios.get(`${BASE_JOBSTATUS_URL}Paginated`, {
            params: {
                currentPage: page,
                pageSize,
                ...filters
            },
            cancelToken: token
        }); 
        return data;
    },


});

export default JobStatusService;